/**
 *  Component: Parent Post Label
 */
import React, { useState } from 'react';

import TextParseComponent from 'components/feed/TextParseComponent';
import { useHistory } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { StyledTooltip } from 'styles/common';

import { getTaskDetailsRoute } from 'constants/helper';

const ParentPostLabel = ({
  fontSize = 'normal',
  parentPosts = {},
  small = false,
  marginLeft = false,
  disabled = false,
}) => {
  const { task } = parentPosts;
  const history = useHistory();
  const [clicked, setClicked] = useState(false);

  if (!task) {
    return <span />;
  }

  const goToTaskDetails = (e) => {
    e.stopPropagation();
    const route = getTaskDetailsRoute({
      location: history.location,
      ids: [task[0].id],
      type: task[0].type,
    });
    setClicked(true);
    history.push(route);
  };

  const TextComponent = ({ color }) => (
    <TextParseComponent text={task[0].text} res={task[0].macros} color={color || 'inherit'} />
  );

  const TitleComponent = () => (
    <>
      Parent task - <TextComponent color="white" />
    </>
  );

  return (
    <StyledTooltip title={clicked ? '' : <TitleComponent />}>
      <Container
        wordBreak
        small={small}
        marginLeft={marginLeft}
        onClick={goToTaskDetails}
        disabled={disabled}
        onMouseEnter={() => setClicked(false)}
      >
        <TextComponent />
      </Container>
    </StyledTooltip>
  );
};

const Container = styled.div`
  background: #ebebeb;
  color: #444;
  display: inline-block;
  max-width: 100%;
  padding: 2px 5px;
  border-radius: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 1px 0 1px 4px;
  ${(props) =>
    props.small &&
    css`
      font-size: 0.7rem;
    `}
  ${(props) =>
    props.marginLeft &&
    css`
      margin-left: 28px;
      max-width: calc(100% - 28px);
    `}
  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
    `}
  &:hover {
    background: #c8c8c8;
    cursor: pointer;
  }
  span {
    white-space: nowrap;
  }
`;

export default ParentPostLabel;
